import { ExistingFirmResponse } from 'api/firm/firm.types';
import { SubmissionFunnelTypeEnum } from './types';
import { getSubmissionRouteUIConfig, isValidFunnelTypeForFirm } from './submissionRouteConfig';

export function resolveInitialFunnelType(
  firm: ExistingFirmResponse,
  savedFunnelType: SubmissionFunnelTypeEnum | '' | undefined,
): SubmissionFunnelTypeEnum {
  const config = getSubmissionRouteUIConfig(firm);

  if (savedFunnelType && isValidFunnelTypeForFirm(firm, savedFunnelType)) {
    return savedFunnelType;
  }

  return config.defaultOption;
}

export type ApiSubmissionFunnelType = 'DIRECT' | 'MORTGAGE_CLUB' | 'NETWORK';

const API_TO_FORM_FUNNEL_TYPE: Record<ApiSubmissionFunnelType, SubmissionFunnelTypeEnum> = {
  DIRECT: SubmissionFunnelTypeEnum.DIRECT,
  MORTGAGE_CLUB: SubmissionFunnelTypeEnum.MORTGAGE_CLUB,
  NETWORK: SubmissionFunnelTypeEnum.NETWORK,
};

export function mapApiSubmissionFunnelTypeToForm(
  apiFunnelType: ApiSubmissionFunnelType | undefined,
): SubmissionFunnelTypeEnum | undefined {
  if (!apiFunnelType) {
    return undefined;
  }

  return API_TO_FORM_FUNNEL_TYPE[apiFunnelType];
}

const FORM_TO_API_FUNNEL_TYPE: Record<SubmissionFunnelTypeEnum, ApiSubmissionFunnelType> = {
  [SubmissionFunnelTypeEnum.DIRECT]: 'DIRECT',
  [SubmissionFunnelTypeEnum.MORTGAGE_CLUB]: 'MORTGAGE_CLUB',
  [SubmissionFunnelTypeEnum.NETWORK]: 'NETWORK',
};

export function mapFormSubmissionFunnelTypeToApi(
  formFunnelType: SubmissionFunnelTypeEnum | undefined,
): ApiSubmissionFunnelType | undefined {
  if (!formFunnelType) {
    return undefined;
  }

  return FORM_TO_API_FUNNEL_TYPE[formFunnelType];
}
